// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Transaction } from '../../../@types';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormEditNonCashBenefit } from '../../forms/FormEditNonCashBenefit/FormEditNonCashBenefit';

// props
export interface DialogEditNonCashBenefitProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
	transaction: Transaction;
}

export const DialogEditNonCashBenefit = ({
	isOpen,
	onClose,
	onSuccess,
	transaction,
}: DialogEditNonCashBenefitProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	// vars
	const propsDialogActions: Partial<DialogActionsProps> = {
		actions: [
			{
				children: t('cancel'),
				onClick: onClose,
			},
			{
				children: t('saveNonCashBenefit'),
				form: 'form-edit-non-cash-benefit',
				loading: isLoading,
				type: 'submit',
				variant: 'contained',
			},
		],
		title: {
			children: t('editNonCashBenefit'),
			variant: 'h3',
		},
	};
	return (
		<DialogActions hasClose={true} isOpen={isOpen} onClose={onClose} {...propsDialogActions}>
			<FormEditNonCashBenefit
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
				transaction={transaction}
			/>
		</DialogActions>
	);
};
